import React from 'react';
import { FormError } from 'components';
import { filterStr, filterStringReducer, isShowButton } from '../utils';
import { Button, Form, TextInput, Dropdown } from 'carbon-components-react';
import { useFormik } from 'formik';
import { SearchUsersSchema } from 'utilities/validation';
import { Filter16, Close16 } from '@carbon/icons-react';

export const providedStatuses: Array<any> = [
  {
    id: '1',
    text: 'Last 15 minutes'
  },
  {
    id: '2',
    text: 'Last hour'
  },
  {
    id: '4',
    text: 'Today'
  },
  {
    id: '5',
    text: 'Last 7 days'
  },
  {
    id: '3',
    text: 'All time'
  }
];
export const providedRoles: Array<any> = [
  {
    id: '1',
    text: 'BYDAADMIN' //CAUTION
  },
  {
    id: '2',
    text: 'AOADMIN'
  },
  {
    id: '3',
    text: 'AOVIEWER'
  },
  {
    id: '4',
    text: 'AOANY'
  },
  {
    id: '5',
    text: 'ENQUIRER'
  },
  {
    id: '6',
    text: 'SYSADMIN'
  }
];

const ApplyFilterForm = ({
  handleSetFilter,
  handleResetFilter,
  filterValues,
  handleOpenCloseFilter,
  handleSetLastLoginFilter,
  handleSetRoleFilter,
  roleFilterValue,
  lastLoginFilterValue
}: any) => {
  const {
    touched,
    errors,
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    resetForm
  } = useFormik({
    enableReinitialize: true,
    initialValues: filterValues,
    validationSchema: SearchUsersSchema,
    onSubmit: (values: any) => {
      const withAdditionalFilters = {
        ...values,
        lastLogin: lastLoginFilterValue,
        role: roleFilterValue
      };
      const formData = Object.entries(withAdditionalFilters).reduce(
        filterStringReducer,
        {}
      );
      const filteredString = filterStr({ formData });
      handleSetFilter(filteredString, values);
    }
  });
  const handleReset = () => {
    resetForm();
    handleResetFilter();
  };
  return (
    <div
      className="
    search-user-filter "
    >
      <div
        className="search-user-filter-button-form"
        onClick={handleOpenCloseFilter}
      >
        <Filter16 />
      </div>
      <section className="search-user-filter-main">
        <Form className="apply-filter-form-wrapper" onSubmit={handleSubmit}>
          <div className="heading">
            <p>Filter the view</p>
            <Button
              kind="ghost"
              size="sm"
              onClick={() => handleOpenCloseFilter(false)}
            >
              <Close16 />
            </Button>
          </div>
          <Dropdown
            id="search-user-last-login"
            titleText="Last login"
            label="today"
            items={providedStatuses}
            itemToString={(item) => (item ? item.text : '')}
            onChange={(item) =>
              handleSetLastLoginFilter({ ...item.selectedItem })
            }
            selectedItem={lastLoginFilterValue}
          />

          <TextInput
            id="email"
            name="email"
            labelText="Email address contains"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          {touched && errors.email && <FormError>{errors.email}</FormError>}
          <TextInput
            id="firstName"
            name="firstName"
            labelText="First name"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.firstName}
          />
          {touched && errors.firstName && (
            <FormError>{errors.firstName}</FormError>
          )}
          <TextInput
            id="lastName"
            name="lastName"
            labelText="Last name"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.lastName}
          />
          {touched && errors.lastName && (
            <FormError>{errors.lastName}</FormError>
          )}
          <TextInput
            id="organisation"
            name="organisation"
            labelText="Organisation name contains"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.organisation}
          />
          {touched && errors.organisation && (
            <FormError>{errors.organisation}</FormError>
          )}
          <TextInput
            id="utilityId"
            name="utilityId"
            labelText="Utility Id"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.utilityId}
          />
          {touched && errors.utilityId && (
            <FormError>{errors.utilityId}</FormError>
          )}
          <Dropdown
            className="apply-filter-form-wrapper-role"
            id="search-user-role"
            titleText="Role"
            label="Choose a role ..."
            items={providedRoles}
            itemToString={(item) => (item ? item.text : '')}
            onChange={(item) => handleSetRoleFilter({ ...item.selectedItem })}
            selectedItem={roleFilterValue}
          />
          <TextInput
            id="phone"
            name="phone"
            labelText="Phone number"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.phone}
          />
          {touched && errors.phone && <FormError>{errors.phone}</FormError>}
          <hr className="search-user-divider" />
          <div className="search-user-apply-form-button-container">
            <Button kind="ghost" onClick={handleReset}>
              Reset Filters
            </Button>
            <Button type="submit" disabled={!isShowButton(errors)}>
              Apply
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};
export default ApplyFilterForm;
